<template>
    <div>
        <div class="card border-0">
            <div class="card-header">
                <span>Contact Information</span>
            </div>
            <div class="card-body gray-bg profile__basic">
                <div class="row justify-content-center pl-4 pr-4 pb-2">
                    <div class="col-md-12" id="basic-info-form">
                        <div class="form-group row">
                            <label for="mobilenumber" class="col-sm-4 col-form-label">Mobile Phone</label>
                            <div class="col-sm-8">
                                <input type="text" required class="form-control" id="mobilenumber" name="mobilenumber" autocomplete="off" v-model="info.mobilenumber" @input="formatMobileNumber()">
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="homenumber" class="col-sm-4 col-form-label">Home Phone</label>
                            <div class="col-sm-8">
                                <input type="text" required class="form-control" id="homenumber" name="homenumber" autocomplete="off" v-model="info.homenumber" @input="formatHomeNumber()">
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="account_email" class="col-sm-4 col-form-label">Account Email</label>
                            <div class="col-sm-8">
                                <input type="email" required class="form-control" id="account_email" name="account_email" autocomplete="off" v-model="info.email">
                                <small class="text-danger small-hint">
                                    This email is used for all account operations and notifications, this should be your "primary" email
                                </small>
                            </div>
                        </div>

                        <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Address</label>
                            <div class="col-sm-8">
                                {{ userInfo.address }}<br>
                                <template v-if="userInfo.address2">{{ userInfo.address2 }}<br></template>
                                {{ userInfo.city }}, {{ userInfo.state }} {{ userInfo.zip }}<br>

                                <div>
                                    <small class="text-danger" v-if="userInfo.pendingAddressChange">
                                        Recent Updates May Be Pending.<br>
                                        *Only confirm if this reflects your recent change request.
                                    </small>
                                    <small v-else>
                                        <a :href="changeAddressLink">Update Address</a>
                                    </small>
                                </div>

                            </div>
                        </div>

                        <div class="form-group row" v-if="false">
                            <label for="address" class="col-sm-4 col-form-label">Address</label>
                            <div class="col-sm-8">
                                <input type="text" required class="form-control" id="address" name="address" v-model="info.address">
                            </div>
                        </div>
                        <div class="form-group row" v-if="false">
                            <label for="city" class="col-sm-4 col-form-label">City</label>
                            <div class="col-sm-8">
                                <input type="text" required class="form-control" id="city" name="city" v-model="info.city">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-4"></div>
                            <div class="pb-3 col-sm-8">
                                <input v-model="info.confirmed" id="confirm-checkbox" type="checkbox">
                                <label class="form-check-label font-weight-normal" for="confirm-checkbox">
                                    I confirm my information is accurate.
                                </label>
                            </div>
                        </div>
                        <div class="form-group row mb-0">
                            <button type="button" class="btn btn-primary" @click="updateUser">Update</button>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <br>
        <div class="card border-0">
            <div class="card-header">
                <span>Health Information</span>
            </div>
            <div class="card-body gray-bg profile__basic">
                <div class="row justify-content-center pl-4 pr-4 pb-2">
                    <div class="col-md-12" id="basic-info-form">
                        <div class="form-group row" v-if="speciality==='N'">
                            <label for="height" class="col-sm-4 col-form-label">Height (In.)</label>
                            <div class="col-sm-8">
                                <input type="text" required class="form-control" id="height" name="height" v-model="info.height">
                            </div>
                        </div>
                        <div class="form-group row" v-if="speciality==='N'">
                            <label for="weight" class="col-sm-4 col-form-label">Weight (Lbs.)</label>
                            <div class="col-sm-8">
                                <input type="text" required class="form-control" id="weight" name="weight" v-model="info.weight">
                            </div>
                        </div>
                        <div class="form-group row" v-if="speciality==='N'">
                            <label for="bloodtype" class="col-sm-4 col-form-label">Blood Type</label>
                            <div class="col-sm-8">
                                <select  required class="form-control" id="bloodtype" name="bloodtype" v-model="info.bloodtype">
                                    <option value="">Please Select</option>
                                    <option v-for="t in types" :value="t.blt_id">{{t.blt_type}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group row" v-if="false">
                            <label for="photo" class="col-sm-4 col-form-label">Profile Photo</label>
                            <div class="col-sm-8">
                                <input type="text" required class="form-control" id="photo" name="photo" v-model="info.photo">
                            </div>
                        </div>
                        <div class="form-group row mb-0">
                            <button type="button" class="btn btn-primary" @click="updateUser">Update</button>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "SbBasicInformation",
        props:[
            'userInfo',
            'types',
            'speciality',
            'changeAddressLink'
        ],
        mounted() {
            this.formatMobileNumber();
            this.formatHomeNumber();
            this.info.confirmed = false;
        },
        data(){
            return {
                route: '/api/basic-info',
                info: this.userInfo,
            }
        },
        methods:{
            formatMobileNumber() {
                if(this.info.mobilenumber){
                    var x = this.info.mobilenumber.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
                    this.info.mobilenumber = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
                }
            },
            formatHomeNumber() {
                if(this.info.homenumber){
                    var x = this.info.homenumber.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
                    this.info.homenumber = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
                }
            },
            updateUser(){
                this.$http.post(this.route, this.info)
                    .then(function(response) {
                        $('.has-error').removeClass('has-error')
                        $('.help-block').remove()
                        this.showModal=false;
                        if(response.bodyText=="1"){
                            this.$notify({
                                type: 'success',
                                title: 'Success',
                                text: 'Information Updated!'
                            });
                        }else{
                            this.$notify({
                                type: 'error',
                                title: 'Success',
                                text: response.bodyText
                            });
                        }
                    }, (response) => {
                        this._handleErrors(response.data, '#basic-info-form')
                    })
            },
            _handleErrors: function(items, selector)
            {
                $('.has-error').removeClass('has-error')
                $('.help-block').remove()

                for (var error in items['errors']) {
                    if (items['errors'].hasOwnProperty(error)) {
                        var text = error;
                        var parts = text.split('.');
                        var name = parts.pop();
                        var el = $(selector + ' [name="'+name+'"]')
                        el.closest('.form-group').addClass('has-error')
                        $( '<p class="help-block">'+(items['errors'][error].join(', '))+'</p>' ).insertAfter(selector + ' [name="'+name+'"]');
                    }
                }
            }
        }
    }
</script>
